import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Center, Wrap } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import { formatAUDate, formatAUTime, formatMobile } from "../global-client";
import { getMessageLog } from "../redux/actions/messageActions";
import MessageLogRow from "./screenComponents/MessageLogRow";

const MessagesLogScreen = () => {
  const dispatch = useDispatch();
  const { loading, error, messageLog, pagination } = useSelector((state) => state.message);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    dispatch(getMessageLog(1));
  }, [dispatch]);

  const paginationButtonClick = (page) => {
    dispatch(getMessageLog(page));
  };

  const selectMsgRow = (row) => {
    console.log("Selected message row: ", row);
    setSelectedRow(row);
  };

  return (
    <>
      {messageLog && messageLog.length >= 1 && (
        <Box p={4}>
          <Wrap spacing='5px' justify='center' minHeight='55vh'>
            {error ? (
              <Alert status='error'>
                <AlertIcon />
                <AlertTitle>We are sorry </AlertTitle>
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            ) : (
              <Box width='100%' p='0' mt='8'>
                <Box overflowX={{ base: "auto", md: "auto" }} w='100%'>
                  <Box w='100%' display='flex' flexDirection='column'>
                    <MessageLogRow
                      key={"header"}
                      id='ID'
                      text='Content'
                      direction='In/Out'
                      toNumber='To Number'
                      fromNumber='From Number'
                      customerName='Customer Name'
                      date='Date'
                      time='Time'
                      jobId='Job No'
                      index={-1}
                      selected={false}
                      header={true}
                      // onSelect={(row) => {
                      //   selectMsgRow(row);
                      // }}
                      mt='8'
                    />
                    {messageLog.map((msg, index) => (
                      <MessageLogRow
                        key={msg.SMSLOG_ID}
                        id={msg.SMSLOG_ID}
                        text={msg.TEXT}
                        direction={msg.DIRECTION}
                        toNumber={formatMobile(msg.TO_NUMBER)}
                        fromNumber={formatMobile(msg.FROM_NUMBER)}
                        customerName={msg.CUST_FNAME ? msg.CUST_FNAME + " " + msg.CUST_SNAME : "N/A"}
                        date={msg.DT_STAMP && formatAUDate(msg.DT_STAMP, { weekday: false })}
                        time={msg.DT_STAMP && formatAUTime(msg.DT_STAMP)}
                        jobId={msg.JOB_ID}
                        index={index}
                        selected={selectedRow === index}
                        header={false}
                        onSelect={(row) => {
                          selectMsgRow(row);
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              </Box>
            )}
          </Wrap>

          <Wrap spacing='10px' justify='center' p='5'>
            <Button
              colorScheme='cyan'
              onClick={() => paginationButtonClick(Math.max(1, pagination.currentPage - 1))}
              isDisabled={pagination.currentPage === 1}
            >
              <ArrowLeftIcon />
            </Button>
            {(() => {
              const pages = [];
              const { currentPage, totalPages } = pagination;
              // Always show first 2 pages
              for (let i = 1; i <= Math.min(2, totalPages); i++) {
                pages.push(
                  <Button
                    colorScheme={currentPage === i ? "cyan" : "gray"}
                    onClick={() => paginationButtonClick(i)}
                    key={i}
                  >
                    {i}
                  </Button>
                );
              }
              // Show "..." if there are more than 4 pages and currentPage > 3
              if (totalPages > 4 && currentPage > 3) {
                pages.push(
                  <Box key='start-ellipsis' px={2}>
                    ...
                  </Box>
                );
              }
              // Show current page if it's not in first 2 or last page
              if (currentPage > 2 && currentPage < totalPages) {
                pages.push(
                  <Button colorScheme='cyan' onClick={() => paginationButtonClick(currentPage)} key={currentPage}>
                    {currentPage}
                  </Button>
                );
              }
              // Show "..." if there are more than 4 pages and currentPage < totalPages - 1
              if (totalPages > 4 && currentPage < totalPages - 1) {
                pages.push(
                  <Box key='end-ellipsis' px={2}>
                    ...
                  </Box>
                );
              }
              // Always show last page if totalPages > 2
              if (totalPages > 2) {
                pages.push(
                  <Button
                    colorScheme={currentPage === totalPages ? "cyan" : "gray"}
                    onClick={() => paginationButtonClick(totalPages)}
                    key={totalPages}
                  >
                    {totalPages}
                  </Button>
                );
              }
              return pages;
            })()}
            <Button
              colorScheme='cyan'
              onClick={() => paginationButtonClick(Math.min(pagination.totalPages, pagination.currentPage + 1))}
              isDisabled={pagination.currentPage === pagination.totalPages}
            >
              <ArrowRightIcon />
            </Button>
          </Wrap>
        </Box>
      )}
      {!loading && (!messageLog || messageLog.length === 0) && (
        <Box textAlign='center' py={10}>
          <Center>No messages found</Center>
        </Box>
      )}
    </>
  );
};

export default MessagesLogScreen;
